import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EPAHoldingQueueDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  EPAHoldingQueueDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: EPAHoldingQueueDetails = {
  isLoading: false,
  error: false,
  message: null,
  EPAHoldingQueueDetailsData: [],
  Items: [],
  Pagination: [],
};

const EPAHoldingQueueDetailsSlice = createSlice({
  name: "EPAHoldingQueueDetails",
  initialState,
  reducers: {
    loadingEPAHoldingQueueDetails: (
      state: EPAHoldingQueueDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setEPAHoldingQueueDetails: (
      state: any,
      action: PayloadAction<EPAHoldingQueueDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: EPAHoldingQueueDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const {
  loadingEPAHoldingQueueDetails,
  setEPAHoldingQueueDetails,
  clearData,
} = EPAHoldingQueueDetailsSlice.actions;
export default EPAHoldingQueueDetailsSlice.reducer;
